<template>
    <div>
        <normal-card class="mt-5">
            <div class="league-match">
                <div class="league-info">
                    <div class="length">
                        <img :src="matchInfo.matchLogo" />
                        <div class="league-detail">
                            <p>{{ matchInfo.matchTitle }}</p>
                        </div>
                    </div>
                    <div class="league-btn">
                        <!-- <div class="changeMatch">
                            <el-dropdown @command="handleMatch">
                                <span style="font-size: 13px;color: #ececec;">
                                    切换赛事<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <div v-for="item in matchList" :key="item.matchId">
                                        <el-dropdown-item :command="item">{{ item.matchTitle }}</el-dropdown-item>
                                    </div>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div> -->
                        <el-button class="addMatchBtn" @click="chooseMatchBtn"
                            style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);">切换赛事</el-button>
                        <el-button class="addMatchBtn" @click="addMatch"
                            style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);">新建赛事</el-button>
                    </div>
                </div>
                <div class="table-area">
                    <div class="changeMatch">
                        <el-image src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/1131-kaishishijian.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>开赛：{{ matchTimeInfo.beginDate }}</span>
                    </div>
                    <div class="addMatch">
                        <el-image src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/1130-jieshushsijian.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>结束：{{ matchTimeInfo.endDate }}</span>
                    </div>
                    <div class="signTeam">
                        <el-image src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/1128-baominrenshu.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>报名球队 {{ matchInfo.teamCount }} /支</span>
                    </div>
                    <div class="signPeople">
                        <el-image src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/1129-cansairenshu.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span> 参赛人数 {{ matchInfo.playerCount }} 人</span>
                    </div>
                </div>
            </div>
        </normal-card>

        <el-dialog :visible.sync="dialogVisible" title="新增赛事" width="80%" @close="closeDialog">
            <el-form label-width="200px" :rules="rules" ref="stepOneForm" :model="stepOneForm">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="赛事logo（建议1：1）" prop="matchLogo">
                            <f-image-upload v-model="stepOneForm.matchLogo" width="150px" height="150px"></f-image-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="赛事海报（建议1：1）" prop="matchPoster">
                            <f-image-upload v-model="stepOneForm.matchPoster" :width="'150px'" :height="'150px'"></f-image-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="对阵图表" prop="matchPoster">
                            <f-image-upload v-model="stepOneForm.matchChart" :width="'150px'" :height="'150px'"></f-image-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="赛事名称" prop="matchTitle">
                            <el-input v-model="stepOneForm.matchTitle"   placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="举办单位" prop="organizer">
                            <el-input v-model="stepOneForm.organizer"   placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="承办球场" prop="stadium">
                            <el-input v-model="stepOneForm.stadium"   placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="球场地址" prop="stadiumAddress">
                            <el-input v-model="stepOneForm.stadiumAddress"   placeholder="请地图选点"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">
                        <el-button type="primary" style="margin-left: 10px" @click="showMap">地图选点</el-button>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="球场经度" prop="longitude">
                            <el-input v-model="stepOneForm.longitude"   placeholder="请地图选点" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="球场纬度" prop="latitude">
                            <el-input v-model="stepOneForm.latitude"   placeholder="请地图选点" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="赛事开始日" prop="beginDate">
                            <el-date-picker v-model="stepOneForm.beginDate" type="date" placeholder="请选择"
                            value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="赛事结束日" prop="endDate">
                            <el-date-picker v-model="stepOneForm.endDate" type="date" placeholder="请选择"
                            value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="赛事类型" prop="matchType">
                            <el-select v-model="stepOneForm.matchType">
                                <el-option v-for="item in propertyOptionList" :key="item.value" :label="item.label" :value="item.value" >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="赛制" prop="matchFormat">
                            <el-select v-model="stepOneForm.matchFormat">
                    <el-option v-for="item in entryOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="组别" prop="matchGroup">
                            <el-select v-model="stepOneForm.matchGroup">
                    <el-option v-for="item in matchGroupList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="场制" prop="matchFieldType">
                            <el-select v-model="stepOneForm.matchFieldType">
                    <el-option v-for="item in matchTypeOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="联系方式" prop="contact">
                            <el-input v-model="stepOneForm.contact" placeholder="请输入" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="举办城市" prop="city">
                            <el-cascader v-model="stepOneForm.city" :options="province.city" clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row :gutter="80">
                    <el-col :span="12" :offset="6">
                        <div class="btn-com">
                        <el-button class="save-btn" @click="fromSave">保存</el-button>
                        </div>
                    </el-col></el-row>
                        <!-- <el-form-item v-for="item of stepOneColumns" :key="item.title" :label="item.title"
                            :prop="item.code">
                            <el-row>
                                <template v-if="item.type === 1">
                                <el-col :span="11">
                                <div style="display: flex;">
                                    <el-input v-model="stepOneForm[item.code]" :disabled="!item.editable" class="wpct30"
                                        placeholder="请输入"></el-input>
                                    <el-button type="primary" v-if="item.code === 'stadiumAddress'"
                                        style="margin-left: 10px" @click="showMap">地图选点</el-button>
                                </div>
                                </el-col>
                            </template>
                            <template v-if="item.type === 2">
                                <el-col :span="11">
                                <el-cascader v-model="stepOneForm[item.code]" :options="province.city"
                                    clearable></el-cascader>
                                </el-col>
                            </template>
                            <template v-if="item.type === 3">
                                <el-col :span="11">
                                <f-image-upload v-model="stepOneForm[item.code]" :width="'150px'"
                                    :height="'150px'"></f-image-upload>
                                </el-col>
                            </template>
                            </el-row>


                            
                        </el-form-item> -->
                    </el-form>
            <!-- <div class="overviewCommand_detail">
                <div class="step-com">
                    <el-steps :active="currentStep" align-center>
                        <el-step v-for="item of steps" :key="item" :title="item"></el-step>
                    </el-steps>
                </div> -->
                <!-- 第一步 -->
                <!-- <div class="step-one" v-if="currentStep === 1">
                    <el-form label-width="240px" ref="stepOneForm" :model="stepOneForm" :rules="rules">
                        <el-form-item v-for="item of stepOneColumns" :key="item.title" :label="item.title"
                            :prop="item.code">
                            <template v-if="item.type === 1">
                                <div style="display: flex;">
                                    <el-input v-model="stepOneForm[item.code]" :disabled="!item.editable" class="wpct30"
                                        placeholder="请输入"></el-input>
                                    <el-button type="primary" v-if="item.code === 'stadiumAddress'"
                                        style="margin-left: 10px" @click="showMap">地图选点</el-button>
                                </div>
                            </template>
                            <template v-if="item.type === 2">
                                <el-cascader v-model="stepOneForm[item.code]" :options="province.city"
                                    clearable></el-cascader>
                            </template>
                            <template v-if="item.type === 3">
                                <f-image-upload v-model="stepOneForm[item.code]" :width="'150px'"
                                    :height="'150px'"></f-image-upload>
                            </template>
                        </el-form-item>
                    </el-form>
                </div> -->
                <!-- 第二步 -->
                <!-- <div class="step-two" v-if="currentStep === 2">
                    <el-form label-width="240px" ref="stepTwoForm" :model="stepTwoForm" :rules="rules">
                        <el-form-item v-for="item of stepTwoColumns" :key="item.title" :label="item.title"
                            :prop="item.code">
                            <template v-if="item.type === 1">
                                <el-input v-model="stepTwoForm[item.code]" disabled class="w-40"></el-input>
                            </template>
                            <template v-if="item.type === 4">
                                <el-date-picker class="wpct30" v-model="stepTwoForm[item.code]" type="date"
                                    placeholder="请选择" value-format="yyyy-MM-dd"></el-date-picker>
                            </template>
                        </el-form-item>
                    </el-form>
                </div> -->
                <!-- 第三步 -->
                <!-- <div class="step-three" v-if="currentStep === 3">
                    <el-form label-width="240px" ref="stepThreeForm" :model="stepThreeForm" :rules="rules">
                        <el-form-item v-for="item of stepThreeColumns" :key="item.title" :label="item.title"
                            :prop="item.code">
                            <template v-if="item.type === 1">
                                <el-input v-model="stepThreeForm[item.code]" class="wpct30" placeholder="请输入" type="number" min="0"><i
                                        slot="suffix">{{ item.suffix }}</i></el-input>
                            </template>
                            <template v-if="item.type === 2">
                                <el-select v-model="stepThreeForm[item.code]" class="wpct30">
                                    <el-option v-for="ops in item.propertyOptionList" :key="ops.value" :label="ops.label"
                                        :value="ops.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-form>
                </div> -->
                <!-- 第四步 -->
                <!-- <div class="step-three" v-if="currentStep === 4">
                    <el-form label-width="240px" ref="stepFourForm" :model="stepFourForm" :rules="rules">
                        <el-form-item v-for="item of stepFourColumns" :key="item.title" :label="item.title"
                            :prop="item.code">
                            <template v-if="item.type === 1">
                                <el-input v-model="stepFourForm[item.code]" class="wpct30" placeholder="请输入"></el-input>
                            </template>
                            <template v-if="item.type === 2">
                                <el-select v-model="stepFourForm[item.code]" class="wpct30">
                                    <el-option v-for="ops in item.propertyOptionList" :key="ops.value" :label="ops.label"
                                        :value="ops.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                        <div v-if="this.stepFourForm.entryType == 0">
                            <el-form-item label="报名费:">
                                <el-input class="inputPrice" placeholder="请输入报名费" v-model="stepFourForm.entryFee"
                                    type="number" style="width: 30%;" min="0">
                                    <i slot="suffix" class="dw">￥/队</i></el-input>
                                <div class="promptText">* 报名费将于报名截止日可发起结算</div>
                            </el-form-item>
                            <el-form-item label="保证金:">
                                <el-input class="inputPrice" placeholder="请输入保证金" v-model="stepFourForm.earnestMoney"
                                    type="number" style="width: 30%;" min="0">
                                    <i slot="suffix" class="dw">￥/队</i></el-input>
                                <div class="promptText">* 保证金需赛事方在比赛结束后线下结算给球队方</div>
                            </el-form-item>
                            <el-form-item label="最少报名球队:">
                                <el-input class="inputMin" v-model="stepFourForm.minSignTeam" style="width: 30%;">
                                    <i slot="suffix" class="dw">/支</i></el-input>
                            </el-form-item>
                            <el-form-item label="最多报名球队:">
                                <el-input class="inputMax" v-model="stepFourForm.maxSignTeam" style="width: 30%;" min="0" type="number">
                                    <i slot="suffix" class="dw">/支</i></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div> -->
                <!-- <div class="btn-com">
                    <el-button type="primary" @click="currentStep -= 1" v-if="currentStep !== 1">上一步</el-button>
                    <el-button type="primary" v-if="currentStep !== steps.length" @click="next">下一步</el-button>
                    <el-button type="primary" class="save-btn" v-if="currentStep === steps.length" @click="handleSave">保存
                    </el-button>
                </div> -->
             <!-- </div> -->
        </el-dialog>
        <el-dialog :visible.sync="matchDialog"  title="选择赛事" width="80%">
            <el-table :data="matchList" border highlight textcenter style="width: 100%" @cell-dblclick="handleMatch">
                    <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
                    <el-table-column prop="matchLogo" label="赛事logo" align="center">
                        <template slot-scope="scope">
                            <el-image style="width: 50px; height: 40px" :src="scope.row.matchLogo"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="matchTitle" label="赛事名称" align="center">
                    </el-table-column>
                    <el-table-column prop="city" label="城市" align="center">
                    </el-table-column>
                    <el-table-column prop="beginDate" label="开始时间" align="center">
                    </el-table-column>
                    <el-table-column prop="endDate" label="结束时间" align="center">
                    </el-table-column>
                </el-table>
                <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
                        :page-size="pageInfo.pageSize" :total="pageInfo.count"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </el-dialog>
        <!-- 地图弹窗 -->
        <el-dialog :visible.sync="showMapDialog" v-if="showMapDialog" title="地图选点">
            <Map @map-submit="mapSubmit" :address="stepOneForm.stadiumAddress"></Map>
        </el-dialog>
    </div>
</template>

<script>
import Map from '@/common/components/MapContainer/Map';
import province from "@/apidata/province.json";
import FImageUpload from '@/common/components/Upload/f-image-upload';
import normalCard from '@/common/components/normal/NormalCard';
export default {
    components: { Map, normalCard, FImageUpload },
    data() {
        return {
            matchFormatInfo: {},
            matchTimeInfo: {},
            matchInfo: {},
            matchList: [],
            title: '',
            currentStep: 1,
            propertyOptionList: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
      entryOption: [
        {
          value: 1,
          label: "联赛制"
        },
        {
          value: 2,
          label: "赛会制"
        },
        {
          value: 3,
          label: "杯赛制"
        },
      ],
      matchTypeOption:[
      {
          value: 5,
          label: '5人制',
        },
        {
          value: 6,
          label: '6人制',
        },
        {
          value: 7,
          label: '7人制',
        },
        {
          value: 8,
          label: '8人制',
        },
        {
          value: 9,
          label: '9人制',
        },
        {
          value: 10,
          label: '10人制',
        },
        {
          value: 11,
          label: '11人制',
        },
      ],
      matchGroupList: [
        {
          value: 1,
          label: '成人组',
        },
        {
          value: 2,
          label: '少儿组',
        },
        {
          value: 5,
          label: 'U5',
        },
        {
          value: 18,
          label: 'U18组',
        },
        {
          value: 30,
          label: '30+组',
        },
        {
          value: 35,
          label: '35+组',
        },
        {
          value: 40,
          label: '40+组',
        },
        {
          value: 50,
          label: '50+组',
        }
      ],
            showMapDialog: false,
            rules: {
                matchLogo: [{ required: true, message: '请上传', trigger: 'change' }],    
                matchPoster: [{ required: true, message: '请上传', trigger: 'change' }],
                matchTitle: [{ required: true, message: '请输入', trigger: 'blur' }],
                organizer: [{ required: true, message: '请输入', trigger: 'blur' }],
                city: [{ required: true, message: '请输入', trigger: 'change' }],
                stadium: [{ required: true, message: '请输入', trigger: 'blur' }],
                stadiumAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
                beginDate: [{ required: true, message: '请选择', trigger: 'change' }],
                endDate: [{ required: true, message: '请选择', trigger: 'change' }],
                matchFieldType: [{ required: true, message: '请选择', trigger: 'change' }],
                matchType: [{ required: true, message: '请选择', trigger: 'change' }],
                matchGroup: [{ required: true, message: '请选择', trigger: 'change' }],
                matchFormat: [{ required: true, message: '请选择赛制', trigger: 'change' }],
                contact: [{ required: true, message: '请输入电话号码', trigger: 'blur' },
                    { pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur', }],
                
            },
            stepOneForm: {
                matchLogo: '',
                matchTitle: '',
                matchPoster: '',
                organizer: '',
                stadium: '',
                stadiumAddress: '',
                longitude: '',
                latitude: '',
                beginDate: '',
                endDate: '',
                matchType: '',
                contact: '',
                matchFormat: '',
                matchFieldType: '',
                matchGroup: '',
                city: '',
                matchChart:''
            },
            stepOneColumns: [
                { title: '赛事logo（建议1:1上传）：', type: 3, code: 'matchLogo', editable: true },
                { title: '赛事名称：', type: 1, code: 'matchTitle', editable: true },
                { title: '主办单位：', type: 1, code: 'organizer', editable: true },
                { title: '举办城市：', type: 2, code: 'city', editable: true },
                { title: '承办球场：', type: 1, code: 'stadium', editable: true },
                { title: '球场地址：', type: 1, code: 'stadiumAddress', editable: false },
            ],
            stepTwoForm: {
                matchType: '',
                beginDate: '',
                endDate: '',
                signBeginDate: '',
                signEndDate: '',
            },
            stepTwoColumns: [
                { title: '赛事类型：', type: 1, code: 'matchType' },
                { title: '赛事开始日：', type: 4, code: 'beginDate' },
                { title: '赛事结束日：', type: 4, code: 'endDate' },
                { title: '报名开始日：', type: 4, code: 'signBeginDate' },
                { title: '报名结束日：', type: 4, code: 'signEndDate' },
            ],
            stepThreeForm: {
                matchFormat: '',
                matchGroup: '',
                teamGroupCount: '',
                teamPlayerCount: '',
                totalGame: '',
                matchType: '',
                entryTeam:''
            },
            stepFourForm: {
                contact: '',
                entryType: '',
                entryFee: 0,
                earnestMoney: 0,
                minSignTeam: 0,
                maxSignTeam: 0
            },
            stepFourColumns: [
                { title: '赛委会电话', type: 1, code: 'contact', editable: true },
                {
                    title: '报名方式：',
                    type: 2,
                    code: 'entryType',
                    propertyOptionList: [
                        {
                            value: 0,
                            label: '付费制',
                        },
                        {
                            value: 1,
                            label: '邀请制',
                        },
                    ],
                },
            ],
            matchData: {
                infoRequest: {},
                extInfoRequest: {},
                formatInfoReqeust: {}
            },
            dialogVisible: false,
            matchDialog: false,
            province: province,
            matchType: [
            {
              value: 1,
              label: '公开赛',
            },
            {
              value: 2,
              label: '过人王',
            },
            {
              value: 3,
              label: '院校赛',
            },
            {
              value: 4,
              label: '青训赛',
            }
            ]
        };
    },
    mounted() {
        this.initmatchList();
        this.initOrgEntryMatchType();
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getMatchDetail();
        }
    },
    methods: {
        // 获取赛事列表
        async initmatchList() {
            const { res } = await this.$http.get('/Match/GetMatchPageList');
            this.matchList = res.data || []
        },
        // 获取用户的可用赛事类型
        async initOrgEntryMatchType() {
            const { res } = await this.$http.get('/Match/MatchTypeList');
            //对象转数组
            const arr = Object.keys(res.data).map(value => ({ value, label: res.data[value] }));
            this.propertyOptionList = arr;
        },
        // 切换赛事
        handleMatch(item) {
            this.$confirm('确认切换赛事吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                localStorage.setItem('matchId', item.matchId);
                localStorage.setItem('currentMatchId', JSON.stringify(item));
                this.matchInfo = item
                location.reload();
            });
        },
        // 获取赛事信息
        async getMatchDetail() {
            const { res } = await this.$http.get(`/Match/MatchInfo/${this.matchInfo.matchId}`);
            this.matchTimeInfo = res.data.info;
            this.matchFormatInfo = res.data.formatInfo
            this.matchTimeInfo.beginDate = this.matchTimeInfo.beginDate.slice(0, 10)
            this.matchTimeInfo.endDate = this.matchTimeInfo.endDate.slice(0, 10)
            this.$emit('match-Type', this.matchFormatInfo.matchFormat)
        },
        // 新增赛事
        addMatch() {
            this.dialogVisible = true
            this.stepTwoForm.matchType = this.matchType.find(item => {
                return item.value = this.userMatchType
            }).label;
        },
        // 赛事列表
        async chooseMatchBtn() {
            this.matchDialog = true
            const params = {
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
            };
            const { res } = await this.$http.get('/Match/GetMatchPageList', { params });
            console.log(res);
            this.matchList = res.data.list || [];
            this.pageInfo.count = res.data.total;
        },
        // 关闭弹窗
        closeDialog() {
            this.dialogVisible = false;
            this.stepFourForm = {};
            this.stepThreeForm = {};
            this.stepTwoForm = {};
            this.stepOneForm = {};
        },
        // 下一步
        next() {
            if (this.currentStep === 1) {
                this.$refs.stepOneForm.validate((valid) => {
                    if (valid) {
                        this.currentStep += 1;
                    }
                });
                return;
            }
            if (this.currentStep === 2) {
                this.$refs.stepTwoForm.validate((valid) => {
                    if (valid) {
                        this.currentStep += 1;
                    }
                });
                return;
            }
            if (this.currentStep === 3) {
                this.$refs.stepThreeForm.validate((valid) => {
                    if (valid) {
                        this.currentStep += 1;
                    }
                });
                return;
            }
        },

        // 保存20240707
        fromSave(){
            this.$refs.stepOneForm.validate((valid) => {
                if (valid) {
                    this.$confirm('请核实信息，确定要发布改赛事吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(async () => {
                        this.stepOneForm.city = this.stepOneForm.city[1];
                        const { res } = await this.$http.post('/Match/SaveMatch', this.stepOneForm);
                        if (res.isSuccess) {
                            this.$showSuccess('发布成功');
                            this.initmatchList()
                            let MatchId = this.matchList.find(item => {
                                return item.matchTitle = this.stepOneForm.infoRequest.matchTitle
                            }).matchId;
                            let currentMatchInfo = this.matchList.find(item => {
                                return item.matchTitle = this.stepOneForm.infoRequest.matchTitle
                            });
                            localStorage.setItem('matchId', MatchId);
                            localStorage.setItem('currentMatchId', JSON.stringify(currentMatchInfo));
                            this.dialogVisible = false;
                            location.reload();
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息！");
                    return
                }
            })
        },
        // 保存方法，第四步校验成功后，拿到所有表单的信息一起保存
        // handleSave() {
        //     this.$refs.stepFourForm.validate((valid) => {
        //         if (valid) {
        //             if (Array.isArray(this.stepOneForm.city)) {
        //                 this.stepOneForm.city = this.stepOneForm.city[1]
        //             }
        //             this.stepTwoForm.matchType = this.userMatchType
        //             this.matchData.infoRequest = Object.assign(this.stepOneForm, this.stepTwoForm)
        //             this.matchData.formatInfoReqeust = this.stepThreeForm
        //             this.matchData.extInfoRequest = this.stepFourForm
        //             this.$confirm('请核实信息，确定要发布改赛事吗？', '提示', {
        //                 confirmButtonText: '确定',
        //                 cancelButtonText: '取消',
        //                 type: 'warning',
        //             }).then(async () => {
        //                 const { res } = await this.$http.post('/Match/SaveMatch', this.matchData);
        //                 if (res.isSuccess) {
        //                     this.$showSuccess('发布成功');
        //                     this.initmatchList()
        //                     let MatchId = this.matchList.find(item => {
        //                         return item.matchTitle = this.matchData.infoRequest.matchTitle
        //                     }).matchId;
        //                     let currentMatchInfo = this.matchList.find(item => {
        //                         return item.matchTitle = this.matchData.infoRequest.matchTitle
        //                     });
        //                     localStorage.setItem('matchId', MatchId);
        //                     localStorage.setItem('currentMatchId', JSON.stringify(currentMatchInfo));
        //                     this.dialogVisible = false;
        //                     location.reload();
        //                 }
        //             });
        //         } else {
        //             this.$message.error("请填写完整信息！");
        //             return
        //         }
        //     });
        // },
        // 地图弹窗
        showMap() {
            this.showMapDialog = true;
        },
        // 选择地址
        mapSubmit(location, address) {
            this.stepOneForm.stadiumAddress = address;
            this.stepOneForm.longitude = location.lng;
            this.stepOneForm.latitude = location.lat;
            this.showMapDialog = false;
        },
        // 分页
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.chooseMatchBtn();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            this.chooseMatchBtn();
        },
    },
};
</script>

<style lang="scss" scoped>
.btn-com {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .save-btn {
    color: #fff;
    background: rgb(51, 64, 84);
    width: 120px;
  }
}

.league-match {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ececec;

    .table-area {
        display: flex;
        justify-content: center;
        border-radius: 0 0 10px 10px;
        width: 100%;
        height: 40px;
        font-size: 18px;
        // background-color: #fff;
        border-top: 1px solid #dbdbdb;

        .addMatch,
        .changeMatch,
        .signTeam,
        .signPeople {
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #dbdbdb;
            // background-color: #e0cd78;
            width: 25%;
        }


        .addMatch {
            // background-color: #78e086;
        }

        .signTeam {
            // background-color: #78b1e0;
        }

        .signPeople {
            border-right: none;
            // background-color: #e078c9;
        }
    }

    .league-info {
        width: 100%;
        height: 100px;
        border-radius: 10px 10px 0 0;
        display: flex;
        align-items: center;
        // background: linear-gradient(rgb(51, 64, 84), #3e8597);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .length {
            display: flex;
            align-items: center;
        }

        img {
            width: 65px;
            height: 65px;
            margin-left: 200px;
            margin-right: 20px;
            border-radius: 50%;
        }

        .league-btn {
            display: flex;
            margin-right: 150px;

            .changeMatch {
                width: 100px;
                height: 30px;
                margin-right: 20px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
            }
        }

        .league-detail {
            margin-left: 30px;

            p {
                font-size: 24px;
            }

            .detail {
                margin-top: 10px;

                span:nth-of-type(1) {
                    color: #2e10db;
                }

                span:nth-of-type(2) {
                    color: #e0cd78;
                    margin-left: 20px;
                }
            }
        }

        .addMatchBtn {
            width: 100px;
            height: 30px;
            color: #fff;
            background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
            border: none;
        }
    }
}
</style>
